const OPTIMIZATION_FINDINGS_CONSTANTS = {
  IMPACT: 'Impact:',
  EFFORT: 'Effort:',
  CONFIDENCE: 'Confidence:',
  PERCENT: '%',
  TOP_OPTIMIZATION_FINDINGS: 'Top Optimization Findings',
  NET_ANNUAL_IMPACT: 'NET ANNUAL IMPACT',
  LICENSE_SAVINGS: 'LICENSE SAVINGS',
  LOADING: 'Loading optimization findings...',
  ERROR_MESSAGE: 'Failed to load optimization findings.',
  RETRY: 'Retry',
} as const;

export default OPTIMIZATION_FINDINGS_CONSTANTS;
